














































































import ItemCardAction from '@/components/card/ItemCardAction.vue'
import toBorderClClass from '@/filters/to-border-cl-class'
import toFontSzClass from '@/filters/to-font-sz-class'
import toTextClClass from '@/filters/to-text-cl-class'
import {Component, Prop, Mixins} from 'vue-property-decorator'
import Assets from '@/mixins/Assets'
import {namespace} from 'vuex-class'

const userAgent = namespace('userAgent')

interface Action {
  title: string
  color?: string
  act: string
  /**
   * @default true
   */
  button?: boolean
}

interface Tag {
  name: string
  color: string
}

interface Thumbnails {
  cert: any
}

@Component({
  components: {
    ItemCardAction,
  },
})
export default class ItemCard extends Mixins(Assets) {
  /**
   * KCard prop
   */
  @Prop({default: false, type: Boolean}) loading: boolean
  /**
   * This title will place into a title position which is top of the card
   */
  @Prop({required: false}) title?: string
  /**
   * Css class .k-text-color-[titleColor]
   */
  @Prop({default: 'gray-800'}) titleColor?: string
  /**
   * Css class .k-text-[titleSize]
   */
  @Prop({default: 'subtitle', validator(value: string): boolean {
    const sizes = [
      'ultra-title', 'mega-title', 'title', 'subtitle', 'subtitle1', 'content', 'mini', 'super-mini',
    ]
    return sizes.indexOf(value) !==-1
    }}) titleSize?: string
  /**
   * Data will place into a tags position left of title
   */
  @Prop({required: false}) tags?: Tag[]
  /**
   * Data will place into an action position
   */
  @Prop({required: false}) actions?: Action[]
  /**
   * This notice will place into a notice position right of title
   */
  @Prop({required: false}) notice?: string
  /**
   * Css class  .k-text-color-[noticeColor]
   */
  @Prop({default: 'gray-600', type: String}) noticeColor: string
  /**
   * Left of content
   */
  @Prop({required: false}) thumbnail?: string
  /**
   * ElButton prop
   */
  @Prop() header: string
  /**
   * ElButton props
   */
  @Prop() bodyStyle: object
  /**
   * ElButton prop
   */
  @Prop() shadow: string
  /**
   * KCard prop
   */
  @Prop({default: false, type: Boolean}) disabled: boolean
  /**
   * Outline color
   */
  @Prop({required: false}) outline?: string
  /**
   * Force to display empty
   */
  @Prop() empty?: boolean

  @userAgent.Getter('isIE') isIE: boolean

  active: boolean = false

  get buildInThumbnails(): Thumbnails {
    return {
      cert: this.img('cert.svg'),
    }
  }

  get bind() {
    const {loading, header, bodyStyle, shadow, disabled} = this
    return {loading, header, bodyStyle, shadow, disabled}
  }

  /**
   * Return thumbnail img from buildInThumbnails or internet
   */
  get thumbnailImg() {
    const {thumbnail} = this
    if(!thumbnail) {
      return undefined
    }
    const img = this.buildInThumbnails[thumbnail]
    if(!img) {
      return thumbnail
    }
    return img
  }

  get cardClasses() {
    return [
      this.outline && toBorderClClass(this.outline),
      this.active ? 'active': '',
    ]
  }

  get titleClasses() {
    return [
      toTextClClass(this.titleColor),
      toFontSzClass(this.titleSize),
    ]
  }

  get noticeClasses() {
    return toTextClClass(this.noticeColor)
  }

  get middleContentStyle() {
    return {
      marginTop: this.thumbnail ? '16px !important' : '',
    }
  }

  onMousedown() {
    if(this.isIE) {
      this.active = true
    }
  }

  onMouseup() {
    if(this.isIE) {
      this.active = false
    }
  }
}
